import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import { ServiceOrdersManagement } from '../../components/admin/ServiceOrdersManagement';

export function OrdersPage() {
  return (
    <AdminLayout
      title="Commandes"
      description="Gérez les commandes de services"
    >
      <ServiceOrdersManagement />
    </AdminLayout>
  );
}
